/**
 * Logger centralizado. Único módulo autorizado a usar console.
 * En producción, solo warn y error salen. debug/info son silenciados.
 */

type LogLevel = 'debug' | 'info' | 'warn' | 'error';

const isProduction = import.meta.env.PROD;
const enabledLevels: Record<LogLevel, boolean> = {
  debug: !isProduction,
  info: !isProduction,
  warn: true,
  error: true,
};

function log(level: LogLevel, message: string, context?: Record<string, unknown>): void {
  if (!enabledLevels[level]) return;

  const payload = { level, message, ts: new Date().toISOString(), ...(context ?? {}) };

  switch (level) {
    case 'debug':
      // eslint-disable-next-line no-console
      console.debug(payload);
      break;
    case 'info':
      // eslint-disable-next-line no-console
      console.info(payload);
      break;
    case 'warn':
      // eslint-disable-next-line no-console
      console.warn(payload);
      break;
    case 'error':
      // eslint-disable-next-line no-console
      console.error(payload);
      break;
  }
}

export const logger = {
  debug: (msg: string, ctx?: Record<string, unknown>) => log('debug', msg, ctx),
  info: (msg: string, ctx?: Record<string, unknown>) => log('info', msg, ctx),
  warn: (msg: string, ctx?: Record<string, unknown>) => log('warn', msg, ctx),
  error: (msg: string, ctx?: Record<string, unknown>) => log('error', msg, ctx),
};
